import React from "react";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import MuiAccordion from "@material-ui/core/Accordion";
import Divider from "@material-ui/core/Divider";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core";
import UploadFile from "../../../../../components/UploadFile/UploadFile";
import { DetailType } from "../../../constants";
import Field from "../../../../../components/Field";
import WeduCheckbox from "../../../../../components/WeduCheckbox/WeduCheckbox";
import { WizardMode } from "../../../../wizard/types";

const Accordion = withStyles({
  root: {
    padding: 0,
    position: "relative",
    backgroundColor: "rgba(0, 0, 0, .01)",
    borderRadius: ".9375rem",
    border: "solid 1px rgba(197,197,197,.3)",
    boxShadow: "none",
    marginTop: 20,
    "&:before": {
      display: "none",
    },
  },
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    cursor: "pointer",
  },
})(MuiAccordionSummary);

const AccordionContent = withStyles(() => ({
  root: {
    display: "block",
  },
}))(MuiAccordionDetails);

const useStyles = makeStyles(() => ({
  mainContainer: {
    backgroundColor: "#f5f6f7",
    borderRadius: 12,
    padding: 16,
  },
  majorName: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#383d4a",
  },
  label: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#383d4a",
    marginTop: 16,
  },
  bigLabel: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#383d4a",
    marginTop: 16,
  },
  content: {
    fontSize: 16,
    fontWeight: "normal",
    color: "#000",
    marginTop: 8,
    wordBreak: "break-word",
  },
  bigContent: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#61657e",
  },
  doubleColumn: {
    width: "50%",
    fontSize: 16,
    fontWeight: "normal",
    color: "#000",
    marginTop: 8,
  },
  examColumnContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },
  examColumn: {
    width: "50%",
  },
  doubleColumnBold: {
    width: "50%",
    fontSize: 14,
    fontWeight: "bold",
    color: "#383d4a",
    marginTop: 8,
  },
  doubleColumnContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },
  branch: {
    marginTop: 8,
    paddingLeft: 16,
  },
  divider: {
    marginTop: 24,
    color: "#dae1ed",
  },
  calcBoard: {
    backgroundColor: "#fff",
    minHeight: 90,
    border: "1px solid #dae1ed",
    marginTop: 16,
    borderRadius: 8,
    padding: "10px 16px",
  },
  calcBoardContent: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#383d4a",
    lineHeight: "34px",
  },
  tuition: {
    marginLeft: 50,
    textDecoration: "line-through",
  },
  otherFees: {
    marginLeft: 16,
    textDecoration: "line-through",
  },
  calcValue: {
    marginLeft: 24,
  },
  arrowIcon: {
    transform: "rotate(90deg)",
  },
  fileUploader: {
    marginBottom: -16,
  },
  accordionContent: {
    "& .table": {
      margin: "0.9em auto",
      display: "table",
    },
    "& .table table": {
      borderCollapse: "collapse",
      borderSpacing: 0,
      width: "100%",
      height: "100%",
    },
    "& .table table td": {
      minWidth: "2em",
      padding: ".4em",
      border: "1px solid hsl(0, 0%, 75%)",
    },
    "& .table table th": {
      minWidth: "2em",
      padding: ".4em",
      border: "1px solid hsl(0, 0%, 75%)",
      fontWeight: "bold",
      background: "hsla(0, 0%, 0%, 5%)",
    },
  },
  checkboxTitle: {
    color: "#383d4a",
    fontSize: 18,
    fontWeight: "bold",
  },
  checkboxContainer: {
    display: "flex",
  },
  checkboxLabel: {
    fontSize: 16,
    color: "#000",
    marginLeft: -3,
    marginTop: 2,
  },
  card: {
    marginTop: 12,
    marginBottom: 20,
    backgroundColor: "#f2f3f4",
    borderRadius: 12,
    padding: "12px 12px 12px 12px",
  },
}));

const IntakePreview = ({ intake, deadline, startDate }) => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.content}>Intake: {intake}</div>
      <div className={classes.doubleColumnContainer}>
        <div className={classes.doubleColumn}>Deadline: {deadline}</div>
        <div className={classes.doubleColumn}>Start Date: {startDate}</div>
      </div>
    </>
  );
};

const ExamsPreview = ({ exams }) => {
  const classes = useStyles();

  return (
    <Grid container spacing={1} className={classes.doubleColumnContainer}>
      {exams.map((exam) => (
        <Grid
          key={exam.name}
          item
          xs={6}
          className={classes.examColumnContainer}
        >
          <div className={classes.examColumn}>Exam: {exam.name}</div>
          <div className={classes.examColumn}>Score: {exam.score}</div>
        </Grid>
      ))}
    </Grid>
  );
};

const OtherFees = ({ otherFees }) => {
  const classes = useStyles();

  return otherFees.length ? (
    <>
      <div className={classes.label}>Other Fees</div>
      {otherFees.map((f) => (
        <div key={f.name + f.amount} className={classes.content}>
          {f.name}: {f.amount}
        </div>
      ))}
    </>
  ) : null;
};

function PreviewProgramHigher({
  programType,
  majorName,
  intakes,
  branches,
  details,
  detailFiles,
  exams,
  tuition,
  commissionAmount,
  durationAmount,
  durationUnit,
  tuitionDurationAmount,
  tuitionDurationUnit,
  otherFees,
  tuitionScholarship,
  tuitionFinancialAid,
  otherFeesSum,
  otherFeesScholarship,
  otherFeesFinancialAid,
  calculatedTuition,
  hasTuitionSupport,
  calculatedOtherFees,
  hasOtherFeesSupport,
  wizardMode,
}) {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState<DetailType>();

  const handleChange = (panel) => (_, newExpanded) => {
    setExpanded(newExpanded ? panel.type : false);
  };

  return (
    <>
      {wizardMode === WizardMode.Create && (
        <div className={classes.card}>
          <Typography className={classes.checkboxTitle}>
            Clone Program
          </Typography>
          <div className={classes.checkboxContainer}>
            <Field
              type="checkbox"
              label={
                <Typography className={classes.checkboxLabel}>
                  Do you want to clone the program for other majors as well?
                </Typography>
              }
              name="isAutoClone"
              component={WeduCheckbox}
            />
          </div>
        </div>
      )}
      <Typography variant="h3">Preview</Typography>
      <div className={classes.mainContainer}>
        <div className={classes.majorName}>Major: {majorName}</div>
        <div className={classes.label}>Program Type</div>
        <div className={classes.content}>{programType}</div>
        <div className={classes.label}>Program Duration</div>
        <div className={classes.content}>
          {durationAmount} {durationUnit?.toLowerCase()}
        </div>
        <div className={classes.label}>Intakes</div>
        {intakes.map((intake) => (
          <IntakePreview key={intake.startDate} {...intake} />
        ))}
        <div className={classes.label}>Branches</div>
        <ul className={classes.branch}>
          {branches.map((branch, i) => (
            <li key={branch + i} className={classes.content}>
              {branch}
            </li>
          ))}
        </ul>
        <div className={classes.label}>Exams</div>
        <ExamsPreview exams={exams} />
        <div className={classes.label}>Tuition</div>
        <div className={classes.doubleColumnContainer}>
          <div className={classes.doubleColumn}>Tuition Fee: {tuition}</div>
          <div className={classes.doubleColumn}>
            Commission: {commissionAmount}
          </div>
        </div>
        <div className={classes.content}>
          Duration: {tuitionDurationAmount} {tuitionDurationUnit?.toLowerCase()}
        </div>
        <OtherFees otherFees={otherFees} />
        <Divider className={classes.divider} />
        <div className={classes.bigLabel}>
          Tuition: <span className={classes.bigContent}>{tuition}</span>
        </div>
        <div className={classes.doubleColumnContainer}>
          <div className={classes.doubleColumnBold}>
            Scholarship: {tuitionScholarship}
          </div>
          <div className={classes.doubleColumnBold}>
            Financial Aid: {tuitionFinancialAid}
          </div>
        </div>
        <Divider className={classes.divider} />
        <div className={classes.bigLabel}>
          Other Fees: <span className={classes.bigContent}>{otherFeesSum}</span>
        </div>
        <div className={classes.doubleColumnContainer}>
          <div className={classes.doubleColumnBold}>
            Scholarship: {otherFeesScholarship}
          </div>
          <div className={classes.doubleColumnBold}>
            Financial Aid: {otherFeesFinancialAid}
          </div>
        </div>
        <div className={classes.calcBoard}>
          <div className={classes.calcBoardContent}>
            Tuition:
            {hasTuitionSupport && (
              <span className={classes.tuition}>{tuition}</span>
            )}
            <span className={classes.calcValue}>{calculatedTuition}</span>
          </div>
          <div className={classes.calcBoardContent}>
            Other Fees:
            {hasOtherFeesSupport && (
              <span className={classes.otherFees}>{otherFeesSum}</span>
            )}
            <span className={classes.calcValue}>{calculatedOtherFees}</span>
          </div>
        </div>
        <Divider className={classes.divider} />
        <div>
          {details.map((item) => (
            <Accordion
              expanded={expanded === item.type}
              onChange={handleChange(item)}
              key={item.type}
            >
              <AccordionSummary
                expandIcon={<ArrowRightIcon className={classes.arrowIcon} />}
              >
                <Typography>{item.typeName}</Typography>
              </AccordionSummary>
              <AccordionContent>
                <div
                  dangerouslySetInnerHTML={{ __html: item.content }}
                  className={classes.accordionContent}
                />
              </AccordionContent>
            </Accordion>
          ))}
          {detailFiles.length > 0 && (
            <>
              <Divider className={classes.divider} />
              <div className={classes.fileUploader}>
                <UploadFile
                  isViewMode
                  uploadedFiles={detailFiles}
                  titleText="Upload Documents/Flyers"
                />
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default React.memo(PreviewProgramHigher);
